import { Dispatch } from 'react'

import { NavigateFunction } from 'react-router-dom'

import { fetchConversation } from '@app/api'
import { ChatAction, ConversationsListStatus } from '@app/hooks'
import {
  closeConversationAndNavigateToMessages,
  handleForbiddenConversationError,
} from '@app/utils'

export const handleConversationStatusChange = async (
  conversationId: number,
  searchParams: URLSearchParams,
  navigate: NavigateFunction,
  dispatch: Dispatch<ChatAction>
) => {
  let conversation: Awaited<ReturnType<typeof fetchConversation>>
  try {
    conversation = await fetchConversation(conversationId)
  } catch (error) {
    if (
      handleForbiddenConversationError(error, () => {
        closeConversationAndNavigateToMessages(navigate)
      })
    ) {
      return
    }

    throw error
  }

  const params = new URLSearchParams(searchParams)

  const isSpam =
    conversation.status !== 'Dispatched' && conversation.status !== 'Pending'
  const status: ConversationsListStatus = isSpam ? 'spam' : 'dispatched'

  params.delete('replied')

  if (isSpam) {
    params.set('status', status)
  } else {
    params.delete('status')
  }

  dispatch({ type: 'SET_REPLY_DETECTION_STATUS', payload: undefined })
  dispatch({ type: 'SET_CONVERSATIONS_LIST_STATUS', payload: status })

  navigate({
    pathname: location.pathname,
    search: params.toString() ? `?${params.toString()}` : '',
  })
}
